import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

export interface DstFormLookupOption {
  value: string;
  label: string;
}

/** Static dropdown options from legacy `dst-form-create-edit-modal.html` (no loadJsonObject). */
export interface DstFormCreateEditLookups {
  formTypes: DstFormLookupOption[];
  yesNo: DstFormLookupOption[];
  formStatuses: DstFormLookupOption[];
}

const PLACEHOLDER_FORM_TYPE = ' ** Please select a Form type ** ';
const PLACEHOLDER_SIGNATURE = ' ** Please select a Signature type ** ';
const PLACEHOLDER_ELECTION = ' ** Please select an Election type ** ';
const PLACEHOLDER_FORM_STATUS = ' ** Please select a Form status ** ';
const PLACEHOLDER_ACTION_FLAG = ' ** Please select an Action flag ** ';

@Injectable({ providedIn: 'root' })
export class DstFormCreateEditService {

  constructor(private http: HttpClient) {}

  /** Legacy template used hard-coded `<option>` lists, not API lookups. */
  getLookups(): Observable<DstFormCreateEditLookups> {
    return of({
      formTypes: [
        { value: ' ', label: PLACEHOLDER_FORM_TYPE },
        { value: 'PDF', label: 'PDF' },
        { value: 'XML Text Box', label: 'XML Text Box' },
        { value: 'Data Collect', label: 'Data Collect' },
        { value: 'Template Form', label: 'Template Form' },
      ],
      yesNo: [
        { value: ' ', label: PLACEHOLDER_SIGNATURE },
        { value: '1', label: 'Yes' },
        { value: '0', label: 'No' },
      ],
      formStatuses: [
        { value: ' ', label: PLACEHOLDER_FORM_STATUS },
        { value: '1', label: 'Active' },
        { value: '0', label: 'Inactive' },
      ],
    });
  }

  getElectionTypeOptions(): DstFormLookupOption[] {
    return [
      { value: ' ', label: PLACEHOLDER_ELECTION },
      { value: '1', label: 'Yes' },
      { value: '0', label: 'No' },
    ];
  }

  getDataCollectActionFlagOptions(): DstFormLookupOption[] {
    return [
      { value: ' ', label: PLACEHOLDER_ACTION_FLAG },
      { value: '1', label: 'Yes' },
      { value: '0', label: 'No' },
    ];
  }

  private postFormEncoded(url: string, params: any): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  create(baseUrl: string, clobData: any, clobSettings: any, globalService: any, filterParams: any, ssoId: string): Observable<any> {
    let params: any = { ...(globalService || {}), ...(filterParams || {}) };
    params.clob_data = JSON.stringify([clobData]);
    params.clob_settings = JSON.stringify([clobSettings]);
    params.sso_id = ssoId;
    return this.postFormEncoded(`${baseUrl}/saveJsonObject?action_code=izxt7h`, params);
  }

  update(baseUrl: string, clobData: any, clobSettings: any, globalService: any, filterParams: any, ssoId: string): Observable<any> {
    let params: any = { ...(globalService || {}), ...(filterParams || {}) };
    params.clob_data = JSON.stringify([clobData]);
    params.clob_settings = JSON.stringify([clobSettings]);
    params.sso_id = ssoId;
    return this.postFormEncoded(`${baseUrl}/saveJsonObject?action_code=o7c2yt`, params);
  }
}
